<template>
  <div>
    <MediaModal
      :show="show"
      :multiple="multiple"
      :title="title"
      :folder="folder"
      :parent="parent"
      :parent-id="parentId"
      :upload="upload"
      @cancel="close"
      @confirm="onConfirm"
    />
  </div>
</template>

<script setup>
import MediaModal from './MediaModal.vue'
import { useProp } from '@/composables/useProp.js'
import { closeDialog } from 'vue3-promise-dialog'
import { ref } from 'vue'

defineProps({
  folder: useProp(String),
  parent: useProp(String),
  parentId: useProp(Number),
  title: useProp(String, 'Medien auswählen'),
  multiple: useProp(Boolean, false),
  upload: useProp(Boolean, true)
})

const show = ref(true)

const onConfirm = (value) => {
  show.value = false
  closeDialog(value)
}

const close = () => {
  closeDialog(null)
}

</script>
